

export const environment = {
  production: true,

  // //Kingdom prod server
  // baseUrl: "http://10.0.1.140:6005",
  // baseUrlSelfservice: "http://10.0.1.140:6009",
  // financeUrl: "http://10.0.1.140:6004",
  // baseUrlMiddleware: "http://10.0.1.140:6011",

  // Kingdom test server
  // baseUrl: '/procurement-api',
  // baseUrlSelfservice: '/supplier-api',
  // financeUrl: '/finance-api',
  // baseUrlMiddleware: '/middleware-api',  

  // // Emtech server
   baseUrl: "https://fidelitysuppliererp.emtechhouse.co.ke/procurement",
   baseUrlSelfservice: "https://fidelitysuppliererp.emtechhouse.co.ke/backend",
   financeUrl: "https://fidelitysuppliererp.emtechhouse.co.ke/finance",
   baseUrlMiddleware: "http://172.16.0.5:9191",

   // Localhost server
//  baseUrl: "http://localhost:3700",
//  baseUrlSelfservice: "http://localhost:1905",
//  financeUrl: "http://localhost:3701",
//  baseUrlMiddleware: "http://localhost:9191",
  
};



